/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_JourneysInputs */



/**
* | output |
* | --- |
* | "Journeys" |
*
* @param {Nav_JourneysInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const nav_journeys = /** @type {((inputs?: Nav_JourneysInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_JourneysInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Trajecten")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Parcours")
	return /** @type {LocalizedString} */ ("Journeys")
});